import FieldProto from "../../proto/field-proto";
import FieldDropdown_PopoverMenu from "./components/popover/popover-menu";
import FieldDropdown_PopoverOption from "./components/option/option";
import FieldDropdown_PopoverMenuMore from "./components/popover/popover-menu-more";
import FieldDropdown_FormValueEmpty from "./render/form/components/value-empty";
import FieldDropdown_FormValueNotEmpty from "./render/form/components/value-not-empty";
import FieldDropdown_TableValueEmpty from "./components/table/value-empty";
import FieldDropdown_TableValueNotEmpty from "./components/table/value-not-empty";
import FieldConfig from "../../proto/field-config";
import {GROUP_SELECT} from "../../../gd/const/fields/field2-groups";
import FieldDropdown_ManagementForm from "./render/management-form";
import FieldDropdown_ManagementPreview from "./render/management-preview";
import FieldDropdown_View from "./render/view";
import FieldDropdown_ViewSmall from "./render/view-small";
import FieldDropdown_InlineEditable from "./render/inline-editable";
import FieldDropdown_InlineValueEmpty from "./components/inline-edit/value-empty";
import FieldDropdown_ValueNotEmpty from "./components/inline-edit/value-not-empty";
import FieldProto_PickerValueNotEmpty from "../../proto/components/picker/value-not-empty";
import FieldProto_PickerValueEmpty from "../../proto/components/picker/value-empty";
import FieldDropdown_FormElement from "./render/form/form-element";
import FieldDropdown_FormElementView from "./render/form/form-element-view";
import FieldDropdown_GlistGroupStandard from "./components/glist-group/standard";
import FieldProto_GlistGroupModern from "./components/glist-group/modern";
import FieldDropdown_GroupByView from "./render/quick-filter-view";
import FieldDropdown_Picker from "./render/picker";
import FieldDropdown_AutomationActionForm from "./render/automation/automation-action-form";
import FieldDropdown_AutomationTriggerForm from "./render/automation/automation-trigger-form";
import FieldDropdown_AutomationConditionForm from "./render/automation/automation-condition-form";
import ImportFromCSVModule from "../../../gd-modules/import-from-csv/import-from-csv-module";
import FieldDropdown_ConditionForm from "./render/condition";
import {ConditionType_Excludes, ConditionType_Includes} from "../../../model2/conditions/condition-types";
import {ColorPalette, ItemColorCoding} from "../../color-coding/color-coding"
import FieldDropdown_Editable from "./render/editable/editable";
import FieldDropdown_TableCell from "./render/table/table-cell";
import {FieldFilterType} from "../../proto/types";
import ModelEntity from "../../../model2/model-entity";

const debug = false
// const debug = "FieldDropdown"

export default class FieldDropdown extends FieldProto {

    public hasOptionWithNullValue   : boolean   // ???
    public noValueOption            : boolean   // if true will add no value option to options list (by default true for custom fields)

    public showMenuMore             : boolean   // whether to show popover bottom more or not - it doesn't work...?
    public scrollToSelected         : boolean   // ???


    public FIELD_DEFAULT_WIDTH = 200;

    constructor(config:FieldConfig) {
        super(config);

        // Type
        this.typeLabel              = "Dropdown"
        this.typeGroup              = GROUP_SELECT
        this.typeDescription        = "Option select (dropdown) field"

        this.clearButton            = _.get(config,'clearButton',true) // experimental becuase used in table cell

        this.filterType             = FieldFilterType.DROPDOWN

        this.icon                   = config.icon || 'i5-dropdown'

        this.conditionTypes         = [ConditionType_Includes, ConditionType_Excludes]

        // special
        this.options                = _.get(config,'options',[]); // [{value, label, color},...]
        this.hasOptionWithNullValue = _.some(this.options, option=>option.value === null);

        this.noValueOption          = _.get(config,'addNoValueOption',true);
        // patch to support noValueOption key
        if (!_.isNil(config.noValueOption)) this.noValueOption = _.get(config,'noValueOption',true);

        this.noValueOptionLabel     = _.get(config,'noValueOptionLabel','None');

        this.noOptionsLabel         = _.get(config,'noOptionsLabel','No options found');

        this.showMenuMore           = _.get(config,'showMenuMore',true);

        this.placeholder            = _.get(config,'placeholder','Please select');

        this.isSearchable           = _.get(config,'isSearchable',true);
        this.isColorCodingAvailable = true
        this.isGroupByAvailable     = true
        this.scrollToSelected       = true

        // core/gd-form/common/form-manager
        this.formType               = 'select';

        _.assign(this.components, {

            InlineValueEmpty        : FieldDropdown_InlineValueEmpty,                                 // inline edit value empty
            InlineValueNotEmpty     : FieldDropdown_ValueNotEmpty,                              // inline edit value not empty

            PickerValueEmpty        : FieldProto_PickerValueEmpty,
            PickerValueNotEmpty     : FieldProto_PickerValueNotEmpty,

            TableValueEmpty         : FieldDropdown_TableValueEmpty,    // is it in use ?
            TableValueNotEmpty      : FieldDropdown_TableValueNotEmpty, // is in in use ?

            glistGroupModern        : FieldProto_GlistGroupModern,
            glistGroupStandard      : FieldDropdown_GlistGroupStandard
        })

        this.components.FormValueEmpty      = FieldDropdown_FormValueEmpty
        this.components.FormValueNotEmpty   = FieldDropdown_FormValueNotEmpty

        this.components.PopoverMenu         = FieldDropdown_PopoverMenu  // popover itself
        this.components.PopoverOption       = FieldDropdown_PopoverOption // menu option component
        this.components.PopoverMenuMore     = this.showMenuMore ? FieldDropdown_PopoverMenuMore : null // menu bottom more area

        this.classes = {
            PopoverMenu                     : _.get(config, 'classes.PopoverMenu', ''),                         // to add classes for popover menu shell
            PopoverMenuScrollContainer      : _.get(config, 'classes.PopoverMenuScrollContainer', 'max-h-200'), // to add classes for popover menu scroll container (max-h-200 for example)
            // PopoverMenuClass            : '', // to add classes for popover menu (w-300 for example)
        }

        this.renderComponents.quickFilterView           = FieldDropdown_GroupByView
        this.renderComponents.formElement               = FieldDropdown_FormElement
        this.renderComponents.formElementView           = FieldDropdown_FormElementView
        this.renderComponents.managementForm            = FieldDropdown_ManagementForm
        this.renderComponents.managementPreview         = FieldDropdown_ManagementPreview

        this.renderComponents.automationActionForm      = FieldDropdown_AutomationActionForm
        this.renderComponents.automationTriggerForm     = FieldDropdown_AutomationTriggerForm
        this.renderComponents.automationConditionForm   = FieldDropdown_AutomationConditionForm
        this.renderComponents.conditionForm             = FieldDropdown_ConditionForm

        this.renderComponents.view                      = FieldDropdown_View
        this.renderComponents.viewSmall                 = FieldDropdown_ViewSmall

        this.renderComponents.picker                    = FieldDropdown_Picker
        this.renderComponents.inlineEditable            = FieldDropdown_InlineEditable

        this.renderComponents.editable                  = FieldDropdown_Editable
        this.renderComponents.tableCell                 = FieldDropdown_TableCell
    }


    /*** DATA FUNCTIONS ***/
    getOptions() {
        return this.options;
    }

    public _getOption(value:any, model?:ModelEntity):any {
        if (this.hasOptionWithNullValue || !_.isNil(value)) {
            // !!! '==' is intentional to make no difference for number and string
            // !!! '==' is intentional to make no difference for number and string
            // !!! '==' is intentional to make no difference for number and string
            const option : any = _.find(this.getOptions(), option => option.value == value); // DON CHANGE !!!
            if (option) return option;
        }

        return false;
    }

    groupValue(value:any) {
        return _.get(this._getOption(value),'value', null);
    }

    groupLabel(value: any): string {
        return _.get(this._getOption(value),'label', this.noValueOptionLabel)
    }

    groupSortValue(value:any) {
        // return this.groupValue(value)
        return _.get(this._getOption(value),'label', '')
    }

    getGraphColor(model: any, params: any): string {
        const value = this.getViewValue(model)
        const colorNumber = _.get(this._getOption(value),'color', null)
        const color = colorNumber ? gd.skin.colors.getCoreColorHEX(colorNumber) : null

        debug && console.log(debug, 'getGraphColor', colorNumber, color, model, params)

        return color ? color : super.getGraphColor(model, params);
    }

    sortValue(value:any) {
        const label = _.get(this._getOption(value),'label', null);
        return label ? label.toLowerCase() : '';
    }

    searchValue(value:any) {
        const label = _.get(this._getOption(value),'label', null);
        return label ? label.toLowerCase() : '';
    }

    getAutomationOptions():any {
        return this.getOptions()
    }

    /*** IMPORT EXPORT ***/

    toJson() {
        let result = super.toJson();
        result.options = this.options;

        return result;
    }

    normalizeToCSVValue(model: any): any {
        const rawValue = super.normalizeToCSVValue(model)
        let res: string = ''
        if (!!rawValue) {
            const option = _.find(this.getOptions(), o => o.value === rawValue);
            if (option) res = option.label
        }
        return res;
    }

    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {
        const searchValue: string = value.toLowerCase().trim()
        const option = _.find(this.getOptions(), o =>
            o.label.toLowerCase().trim() === searchValue
        )

        if (option) return option.value
        return null
    }

    getColorCoding(model: any): ItemColorCoding {
        const value     = _.get(model, this.fieldId, null)
        const option    = this._getOption(value)

        if (!_.isNil(option.color)) {
            return {
                colorNumber     : option.color,
                corePalette     : ColorPalette.CORE
            }
        } else {
            return super.getColorCoding(model)
        }
    }
}
